import { useMemo, useState } from "react";

import { AiChatSession } from "../types";
import { groupAiChatHistoryChatsByUpdatedAt } from "./utils";

const useAiChatHistory = (chats: AiChatSession[]) => {
  const [searchInput, setSearchInput] = useState("");

  const filteredChats = useMemo(() => {
    return chats.filter((chat) => chat.name.toLowerCase().includes(searchInput.toLowerCase()));
  }, [chats, searchInput]);

  const sections = groupAiChatHistoryChatsByUpdatedAt(filteredChats, new Date());
  const noSearchResults = filteredChats.length === 0 && chats.length > 0;

  return {
    searchInput,
    setSearchInput,
    sections,
    noSearchResults,
  };
};

export default useAiChatHistory;
